module.exports = __webpack_public_path__ + "img/promotion-1.3d36776a.png";